import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { MemberAuthProvider } from "./context/MemberAuthContext";
import SiteLayout from "./components/SiteLayout";
import ProtectedRoute from "./components/ProtectedRoute";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import LeadershipPage from "./pages/LeadershipPage";
import MembersPage from "./pages/MembersPage";
import EventsPage from "./pages/EventsPage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminMembersPage from "./pages/AdminMembersPage";
import MemberLoginPage from "./pages/MemberLoginPage";
import MemberPortalPage from "./pages/MemberPortalPage";

const Shell = ({ children }) => <SiteLayout>{children}</SiteLayout>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <MemberAuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/" element={<Shell><HomePage /></Shell>} />
              <Route path="/about" element={<Shell><AboutPage /></Shell>} />
              <Route path="/leadership" element={<Shell><LeadershipPage /></Shell>} />
              <Route path="/members" element={<Shell><MembersPage /></Shell>} />
              <Route path="/events" element={<Shell><EventsPage /></Shell>} />
              <Route path="/contact" element={<Shell><ContactPage /></Shell>} />

              {/* Member portal */}
              <Route path="/member-login" element={<MemberLoginPage />} />
              <Route path="/member-portal" element={<MemberPortalPage />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/members"
                element={
                  <ProtectedRoute>
                    <AdminMembersPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </MemberAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
